module.exports = __webpack_public_path__ + "img/logo_small.fdd74693.svg";